import { useMutation } from "@tanstack/react-query"
import { useState } from "react"
import GameScreenLayout from "@/components/GameScreenLayout"
import { changeCardStyle } from "@/api/gameApi"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"
import { PlayStyle } from "@/types/battle"
import { STYLE_ICONS } from "@/constants/guardians"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"

const STYLES: PlayStyle[] = ["ATTACK", "DEFENSE", "SPEED"]

export default function CardWardrobePage() {
  const { collectionCards, syncGameState, bumpCards } = useGuardiansPassport()
  const [cardId, setCardId] = useState("")
  const [style, setStyle] = useState<PlayStyle>("ATTACK")

  const change = useMutation({
    mutationFn: () => changeCardStyle(cardId, style),
    onSuccess: async () => {
      await syncGameState()
      bumpCards()
    },
  })

  const card = collectionCards.find((c) => c.id === cardId)

  return (
    <GameScreenLayout title="Гардероб стилей" backTo="/play/collection">
      <select
        value={cardId}
        onChange={(e) => setCardId(e.target.value)}
        className="mb-3 w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm"
      >
        <option value="">Карта</option>
        {collectionCards.map((c) => (
          <option key={c.id} value={c.id}>
            {c.element} {STYLE_ICONS[c.style]} Lv.{c.level}
          </option>
        ))}
      </select>

      {card?.styleChangedAt ? (
        <p className="mb-2 text-xs text-amber-200">
          Стиль уже менялся — повтор может быть недоступен.
        </p>
      ) : null}

      <div className="mb-4 flex gap-2">
        {STYLES.map((s) => (
          <button
            key={s}
            type="button"
            onClick={() => setStyle(s)}
            className={
              style === s
                ? "flex-1 rounded-lg bg-guardians-accent py-2 text-guardians-bg"
                : "flex-1 rounded-lg border border-white/20 py-2"
            }
          >
            {STYLE_ICONS[s]} {s}
          </button>
        ))}
      </div>

      <button
        type="button"
        disabled={!cardId || change.isPending}
        onClick={() => change.mutate()}
        className="w-full rounded-xl border border-white/20 py-3 text-sm"
      >
        Сменить стиль
      </button>

      {change.isError ? (
        <p className="mt-3 text-sm text-red-300">
          {getGameApiErrorMessage(change.error, "Не удалось сменить стиль")}
        </p>
      ) : null}
    </GameScreenLayout>
  )
}
